import * as tslib_1 from "tslib";
import { EvalStack } from '@swim/recon';
import { Model } from '../model';
import { HtmlModel } from './html-model';
var StylesheetModel = (function (_super) {
    tslib_1.__extends(StylesheetModel, _super);
    function StylesheetModel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    StylesheetModel.prototype.willRemodel = function (state, stack) {
        _super.prototype.willRemodel.call(this, state, stack);
        var rules = this._modelScope._record.evaluate(stack);
        state.slot('rules', rules);
    };
    StylesheetModel.prototype.stack = function () {
        if (this._parentModel) {
            return this._parentModel.stack();
        }
        else {
            return EvalStack.of(Model.GlobalScope);
        }
    };
    return StylesheetModel;
}(HtmlModel));
export { StylesheetModel };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3R5bGVzaGVldC1tb2RlbC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbInN0eWxlc2hlZXQtbW9kZWwudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBLE9BQU8sRUFBQyxTQUFTLEVBQVMsTUFBTSxhQUFhLENBQUM7QUFDOUMsT0FBTyxFQUFDLEtBQUssRUFBQyxNQUFNLFVBQVUsQ0FBQztBQUMvQixPQUFPLEVBQUMsU0FBUyxFQUFDLE1BQU0sY0FBYyxDQUFDO0FBRXZDO0lBQXFDLDJDQUFTO0lBQTlDOztJQWVBLENBQUM7SUFkQyxxQ0FBVyxHQUFYLFVBQVksS0FBYSxFQUFFLEtBQWdCO1FBQ3pDLGlCQUFNLFdBQVcsWUFBQyxLQUFLLEVBQUUsS0FBSyxDQUFDLENBQUM7UUFFaEMsSUFBTSxLQUFLLEdBQUcsSUFBSSxDQUFDLFdBQVcsQ0FBQyxPQUFPLENBQUMsUUFBUSxDQUFDLEtBQUssQ0FBQyxDQUFDO1FBQ3ZELEtBQUssQ0FBQyxJQUFJLENBQUMsT0FBTyxFQUFFLEtBQUssQ0FBQyxDQUFDO0lBQzdCLENBQUM7SUFFRCwrQkFBSyxHQUFMO1FBQ0UsRUFBRSxDQUFDLENBQUMsSUFBSSxDQUFDLFlBQVksQ0FBQyxDQUFDLENBQUM7WUFDdEIsTUFBTSxDQUFDLElBQUksQ0FBQyxZQUFZLENBQUMsS0FBSyxFQUFFLENBQUM7UUFDbkMsQ0FBQztRQUFDLElBQUksQ0FBQyxDQUFDO1lBQ04sTUFBTSxDQUFDLFNBQVMsQ0FBQyxFQUFFLENBQUMsS0FBSyxDQUFDLFdBQVcsQ0FBQyxDQUFDO1FBQ3pDLENBQUM7SUFDSCxDQUFDO0lBQ0gsc0JBQUM7QUFBRCxDQUFDLEFBZkQsQ0FBcUMsU0FBUyxHQWU3QyJ9